import { observable, action, computed, makeObservable } from "mobx";

export class EmailLinkedViewStore {
  showLinkedMailId: string = null;

  constructor() {
    makeObservable(this, {
      showLinkedMailId: observable,
      showLinkedMailVisible: computed,
      showLinkedMail: action.bound,
    });
  }

  get showLinkedMailVisible() {
    return this.showLinkedMailId !== null;
  }

  showLinkedMail(mailId: string) {
    this.showLinkedMailId = mailId;
  }
}

export const emailLinkedViewStore = new EmailLinkedViewStore();
